import { buildQuery, buildVoidQuery } from '@/utils/react-query'

import {
  dashboardPredictionYears,
  dashboardCensusYears,
  dashboardCitiesByState,
  dashboardSchoolsByCity,
  dashboardYearGrades,
  dashboardPrediction,
  dashboardPredictionEducationStages,
  dashboardCensus,
  dashboardCensusEducationStages,
  dashboardComparative,
  dashboardComparativeEducationStages,
  dashboardPanoramaOverview,
  dashboardPanoramaStates,
} from './services'
import type {
  DashboardPredictionYearsResponse,
  DashboardCensusYearsResponse,
  DashboardCitiesByStatePayload,
  DashboardCitiesByStateResponse,
  DashboardSchoolsByCityPayload,
  DashboardSchoolsByCityResponse,
  DashboardYearGradesResponse,
  DashboardPredictionPayload,
  DashboardPredictionResponse,
  DashboardPredictionEducationStagesPayload,
  DashboardPredictionEducationStagesResponse,
  DashboardCensusPayload,
  DashboardCensusResponse,
  DashboardCensusEducationStagesPayload,
  DashboardCensusEducationStagesResponse,
  DashboardComparativePayload,
  DashboardComparativeResponse,
  DashboardComparativeEducationStagesPayload,
  DashboardComparativeEducationStagesResponse,
  DashboardPanoramaPayload,
  DashboardPanoramaOverviewResponse,
  DashboardPanoramaStatesResponse,
} from './types'

export const useDashboardPredictionYears =
  buildVoidQuery<DashboardPredictionYearsResponse>(
    'dashboard-prediction-years',
    dashboardPredictionYears
  )

export const useDashboardCensusYears =
  buildVoidQuery<DashboardCensusYearsResponse>(
    'dashboard-census-years',
    dashboardCensusYears
  )

export const useDashboardCitiesByState = buildQuery<
  DashboardCitiesByStateResponse,
  DashboardCitiesByStatePayload
>('dashboard-cities-by-state', dashboardCitiesByState)

export const useDashboardSchoolsByCity = buildQuery<
  DashboardSchoolsByCityResponse,
  DashboardSchoolsByCityPayload
>('dashboard-schools-by-city', dashboardSchoolsByCity)

export const useDashboardYearGrades =
  buildVoidQuery<DashboardYearGradesResponse>(
    'dashboard-year-grades',
    dashboardYearGrades
  )

export const useDashboardPrediction = buildQuery<
  DashboardPredictionResponse,
  DashboardPredictionPayload
>('dashboard-prediction', dashboardPrediction)

export const useDashboardPredictionEducationStages = buildQuery<
  DashboardPredictionEducationStagesResponse,
  DashboardPredictionEducationStagesPayload
>('dashboard-prediction-education-stages', dashboardPredictionEducationStages)

export const useDashboardCensus = buildQuery<
  DashboardCensusResponse,
  DashboardCensusPayload
>('dashboard-census', dashboardCensus)

export const useDashboardCensusEducationStages = buildQuery<
  DashboardCensusEducationStagesResponse,
  DashboardCensusEducationStagesPayload
>('dashboard-census-education-stages', dashboardCensusEducationStages)

export const useDashboardComparative = buildQuery<
  DashboardComparativeResponse,
  DashboardComparativePayload
>('dashboard-comparative', dashboardComparative)

export const useDashboardComparativeEducationStages = buildQuery<
  DashboardComparativeEducationStagesResponse,
  DashboardComparativeEducationStagesPayload
>('dashboard-comparative-education-stages', dashboardComparativeEducationStages)

export const useDashboardPanoramaOverview = buildQuery<
  DashboardPanoramaOverviewResponse,
  DashboardPanoramaPayload
>('dashboard-panorama-overview', dashboardPanoramaOverview)

export const useDashboardPanoramaStates = buildQuery<
  DashboardPanoramaStatesResponse,
  DashboardPanoramaPayload
>('dashboard-panorama-states', dashboardPanoramaStates)
